export default __webpack_public_path__ + "static/media/map-pin-lightning-cog.7f6db6a2.svg";